export const GlobalVariable = {
  SITE_NAME: 'Awahe Admin',
  tokenKey: 'Smartpath_token' ,
  languageType :1 ,
};   


